import React from 'react';
import {
	Component,
	ComponentTypes,
	defaultComponentDimensions,
	Field,
	getAllFields,
} from '../../../common/componentUtils';
import { DataPreFilledType } from '../../../constants';
import { Annotation } from '../../../pages/Prepare/Annotations';
import { GenericFieldComponent } from '../GenericFieldComponent';
import { MandatoryFieldIndicator } from '../MandatoryFieldIndicator';
import { MergeFieldComponent } from '../MergeFieldComponent';

interface StaticFieldProps {
	component: Component;
	scale: number;
	width: number;
	height: number;
	handleComponentUpdate: (comp: Component[], val: string) => void;
	setComponentsToEdit: (component: Component[]) => void;
	componentsToEdit: Component[];
	textAnnotationZIndex: number;
	updateTextAnnotationZIndex: (comp: any) => void;
}

export const StaticField = ({
	component,
	width,
	height,
	handleComponentUpdate,
	setComponentsToEdit,
	componentsToEdit,
	textAnnotationZIndex,
	updateTextAnnotationZIndex,
	scale,
}: StaticFieldProps) => {
	const { labelThresholdWidth } = defaultComponentDimensions[component.type];
	const fields: Field[] = getAllFields();
	const field = fields.find(f => f.type === component.type);

	const isCheckComponent = () =>
		component.type === ComponentTypes.CheckComponent ||
		component.type === ComponentTypes.CheckGroupComponent;

	const isMergeField =
		component.dataPreFilledType === DataPreFilledType.SourceMapped ||
		component.dataPreFilledType === DataPreFilledType.Manual;

	if (
		component.isAnnotation ||
		(component.type as string).match(/annotation/i) !== null
	) {
		return (
			<Annotation
				component={component}
				field={field}
				width={width}
				height={height}
				handleComponentUpdate={handleComponentUpdate}
				setComponentsToEdit={setComponentsToEdit}
				componentsToEdit={componentsToEdit}
				textAnnotationZIndex={textAnnotationZIndex}
				updateTextAnnotationZIndex={updateTextAnnotationZIndex}
				scale={scale}
			/>
		);
	} else if (isCheckComponent()) {
		return component.isRequired ? (
			<MandatoryFieldIndicator
				displayOutside={labelThresholdWidth > width}
				scale={scale}
			/>
		) : null;
	} else if (isMergeField) {
		return <MergeFieldComponent {...{ component, field, scale, width }} />;
	} else {
		return <GenericFieldComponent {...{ component, field, scale, width }} />;
	}
};
